import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Tabs } from './ui/Tabs';
import { EventCard } from './ui/EventCard';
import { MOCK_VEHICLES, Vehicle } from '../utils/mockData';
interface EventStreamProps {
  onVehicleClick: (vehicle: Vehicle) => void;
}
export function EventStream({
  onVehicleClick
}: EventStreamProps) {
  const [activeTab, setActiveTab] = useState('entry');
  const filteredVehicles = activeTab === 'entry' ? MOCK_VEHICLES.filter(v => v.status === 'Inside') : MOCK_VEHICLES.filter(v => v.status === 'Exited');
  return <Card className="flex h-full flex-col overflow-hidden" noPadding data-id="element-77">
      <div className="border-b border-gray-800 p-4" data-id="element-78">
        <div className="flex items-center justify-between mb-4" data-id="element-79">
          <h2 className="text-lg font-semibold text-white" data-id="element-80">
            Live Event Stream
          </h2>
          <div className="flex items-center gap-2" data-id="element-81">
            <span className="flex h-2 w-2 rounded-full bg-red-500 animate-pulse" data-id="element-82" />
            <span className="text-xs text-gray-400" data-id="element-83">Live</span>
          </div>
        </div>
        <Tabs activeTab={activeTab} onChange={setActiveTab} tabs={[{
        id: 'entry',
        label: 'Entry Events'
      }, {
        id: 'exit',
        label: 'Exit Events'
      }]} data-id="element-84" />
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3 custom-scrollbar" data-id="element-85">
        {filteredVehicles.map(vehicle => <EventCard key={vehicle.id} vehicle={vehicle} onClick={onVehicleClick} data-id="element-86" />)}
      </div>
    </Card>;
}